import { majorFromMinor } from '@/shared/lib/money';
import { formatMoney } from '@/shared/lib/format';

export function stripeAmount(minor: number, currency: string, language: string): string {
  return formatMoney(
    majorFromMinor(minor, currency),
    currency,
    language.startsWith('de') ? 'de-DE' : 'en-GB',
  );
}
export function stripeDate(value: string, language: string): string {
  return new Intl.DateTimeFormat(language.startsWith('de') ? 'de-DE' : 'en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}
